import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ListItem} from "../../../../../objects/listItem";
import {ConfirmationDialogComponent} from "../../../../confirmation-dialog/confirmation-dialog.component";
import {AppComponent} from "../../../../../app.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-trainer-item',
  templateUrl: './trainer-item.component.html',
  styleUrls: ['./trainer-item.component.css']
})
export class TrainerItemComponent implements OnInit {

  @Input() listItem: ListItem;
  @Output() click = new EventEmitter<object>();

  constructor(public confirmationDialog: MatDialog) { }

  ngOnInit(): void {
  }

  public clickOnItemMenu(event: MouseEvent): void {
    event?.stopImmediatePropagation()
  }
  showTrainerPhone(): void {
    const name = this.listItem['itemFullData']['shipping_name'];
    const tel = this.listItem['itemFullData']['shipping_phone'];
    const dialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {
      width: '22vw',
      height: '18vh',
      autoFocus: false,
      panelClass: 'common-dialog',
      data: {
        title: name,
        message: AppComponent.getLabel('trainer_phone')+': <a href="tel:'+tel+'">'+tel+'</a>',
        cancelLabel: AppComponent.getLabel('close')
      }
    });
  }

}
